import * as React from 'react';
import styled from 'styled-components';
import { TextAreaContentEditor } from '@doltech/ui/lib/figma/Input/TextAreaContentEditor/TextAreaContentEditor';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';

const Container = styled.div`
  .small-paragraph-spacing {
    padding: 0;
  }

  .text-area-content-editor {
    span, p {
      font-weight: 400;
      font-size: 16px;
      line-height: 28px;
      color: ${colorsV2.neutral140};
    }

    strong span {
      font-weight: inherit;
    }
  }
`;

interface DescriptionBlogEditorGrammarProps {
  value?: any;
  isReadOnly?: boolean;
}

export const DescriptionBlogEditorViewOnlyGrammar = (props: DescriptionBlogEditorGrammarProps) => {
  const { value } = props;

  return (
    <Container className="description-blog-editor-grammar">
      <TextAreaContentEditor
        key="description"
        value={value}
        readonly
      />
    </Container>
  );
};
